import React from "react";

const LessonManagerSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {/* Skeleton Items - create 6 of them */}
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden bg-white dark:bg-gray-800 animate-pulse"
        >
          {/* Thumbnail skeleton */}
          <div className="bg-gray-200 dark:bg-gray-700 h-32 w-full"></div>
          
          {/* Content skeleton */}
          <div className="p-5">
            {/* Title skeleton */}
            <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-md w-3/4 mb-3"></div>
            
            {/* Description skeleton - two lines */}
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-full mb-2"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-2/3"></div>
          </div>
          
          {/* Footer skeleton */}
          <div className="p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-750 flex justify-between items-center">
            {/* Date skeleton */}
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-20"></div>
            
            {/* Actions skeleton */}
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Table skeleton for list view
const TableSkeleton = () => {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
      {/* Table header skeleton */}
      <div className="bg-gray-50 dark:bg-gray-750 px-6 py-3">
        <div className="grid grid-cols-4 gap-4">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
        </div>
      </div>
      
      {/* Table rows skeleton */}
      {[...Array(6)].map((_, i) => (
        <div key={i} className="bg-white dark:bg-gray-800 px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <div className="grid grid-cols-4 gap-4 items-center">
            <div className="flex items-center space-x-3">
              <div className="h-10 w-10 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-md w-24"></div>
            </div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-md w-20"></div>
            <div className="flex justify-end space-x-2">
              <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
              <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Empty state skeleton
const EmptyStateSkeleton = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 p-16 rounded-lg flex flex-col items-center justify-center text-center animate-pulse">
      <div className="mb-6 p-4 bg-gray-200 dark:bg-gray-600 rounded-full h-16 w-16"></div>
      <div className="h-6 bg-gray-200 dark:bg-gray-600 rounded-md w-48 mb-4"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded-md w-64 mb-2"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded-md w-72 mb-2"></div>
      <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded-md w-56 mb-6"></div>
      <div className="h-10 bg-gray-200 dark:bg-gray-600 rounded-lg w-48"></div>
    </div>
  );
};

// Main skeleton component that can be toggled between grid/list view
const LessonSkeletons = ({ displayMode = "grid" }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="p-6">
        {/* Header skeleton with count and view toggle */}
        <div className="mb-6 flex items-center justify-between">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-md w-32"></div>
          <div className="flex space-x-2">
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-md"></div>
          </div>
        </div>
        
        {/* Conditional rendering of grid or list skeletons */}
        {displayMode === "grid" ? <LessonManagerSkeleton /> : <TableSkeleton />}
      </div>
    </div>
  );
};

export default LessonSkeletons;